// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

// function AdminProtected(props) {
//     const { Component, ...rest } = props; // Destructure Component and rest of the props

//     const navigate = useNavigate();

//     useEffect(() => {
//         let login = localStorage.getItem('admin-token');

//         if (!login) {
//             // // // console.log("Login with Correct token!!");
//             navigate("/adminlogin");
//         }
//     }, [navigate]); // Include navigate as a dependency

//     return (
//         <div>
//             <Component {...rest} /> {/* Pass rest of the props to Component */}
//         </div>
//     );
// }

// export default AdminProtected;


import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminProtected = ({ Component }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'admin') {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <h1>⛔ Access Denied</h1>
        <p>You need admin privileges to access this page.</p>
        <button onClick={() => window.history.back()}>Go Back</button>
      </div>
    );
  }

  return <Component />;
};

export default AdminProtected;